import environment from "./environment"

export const debugLog = (...any: any) => {
    if (environment.local) {
        console.log(...any)
    }
}
